import { ensure, numberType, stringType, TType } from "types";

export interface ICostCenter {
  name: string;
  description: string | null;
  number: string;
  systemIdNumber: number;
}

export const configCostCenterType: TType<ICostCenter> = {
  name: stringType(""),
  description: stringType(null),
  number: stringType(""),
  systemIdNumber: numberType(0),
};

export const costCenterType = ensure(configCostCenterType);
